"use client";

import { useState, useEffect } from "react";
import { useFetchNewsData } from "@/hooks/fetchNewsData";
import LoadingSkeleton from "../loading";
import MyCard from "@/components/core/Card";
import Core from "@/components/core";
import Image from "next/image";

const NewsData = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const newsData = useFetchNewsData();
  const itemsPerPage = 4; // Misalnya, menampilkan 4 item per halaman

  // Menghitung item berdasarkan halaman
  const totalItems = newsData?.data?.length || 0;
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = newsData?.data?.slice(startIndex, endIndex);

  const goToNextPage = () => {
    if (currentPage < Math.ceil(totalItems / itemsPerPage) - 1) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isLoading ? (
        <LoadingSkeleton />
      ) : newsData?.status === 200 && newsData?.data.length > 0 ? (
        <>
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-[30px]">
            {currentItems?.map((item) => (
              <MyCard
                caseType="blog"
                key={item.id}
                title={item.title}
                content={item.description}
                image={`https://admin.macspace.id/public/${item.image}`}
                link={item.slug}
              />
            ))}
          </div>
          <div className="grid md:grid-cols-12 grid-cols-1 mt-8">
            <Core.Pagination
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onNextPage={goToNextPage}
              onPreviousPage={goToPreviousPage}
            />
          </div>
        </>
      ) : (
        <div className="text-center py-8">
          <Image
            src="/images/data-not-found.webp"
            alt="No data available"
            width={300}
            height={300}
            className="mx-auto"
          />
          <p className="text-slate-500 mt-4">No data available</p>
        </div>
      )}
    </>
  );
};

export default NewsData;
